export default class IllegalUndo extends Error
{}
